export enum ProductCategory {
    BOILER = 'BOILER',
    PART = 'PART',
    HEAVY_PART = 'HEAVY_PART',
}
export enum ProductUseType {
    AS = 'AS',
    SALE = 'SALE',
}

export const PRODUCT_CATEGORY_SET: ProductCategory[] = [
  ProductCategory.BOILER,
  ProductCategory.PART,
  ProductCategory.HEAVY_PART,
];

export const PRODUCT_USE_TYPE_SET: ProductUseType[] = [
  ProductUseType.AS,
  ProductUseType.SALE,
];
